import { useStore } from './useStore';

export function useSelector(selectorFn = () => {}) {
    const [state] = useStore();
    return selectorFn(state);
}
